import { useEffect, useState } from "react";
import { useFormik } from "formik";
import { useNavigate, useParams } from "react-router-dom";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import InputField from "../../../../components/InputField";
import api from "../../../../api/api";
import * as Yup from "yup";
import { Modal } from "react-bootstrap";
import Button from "../../../../components/Button";
import Breadcrumbs from "../../../../components/Breadcrumbs";
import { useAuth } from "../../../../context/AuthContext";
import DatePicker from "react-datepicker";
 
const ShippingForm = () => {
  const { id } = useParams();
  const { user } = useAuth();
  const [enquiry, setEnquiry] = useState();
  const [showConfirm, setShowConfirm] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const navigate = useNavigate();
  useEffect(() => {
    const fetchEnquiry = async () => {
      try {
        const response = await api.get(`/enquiry/viewEnquiry/${id}`);
        // console.log("response", response.data);
        setEnquiry(response.data);
      } catch (error) {
        console.error(error);
      }
    };
 
    fetchEnquiry();
  }, [id]);
  const handleSuccessClose = () => {
    setShowSuccess(false);
    // Navigate based on user role
    if (user?.user_role === "Admin" || user?.user_role === "SuperAdmin") {
      navigate("/list-of-bl/admin");
    } else if (user?.user_role === "sales_rep") {
      navigate("/freight-enquiries");
    } else {
      navigate("/my-bookings/list-of-bl");
    }
  };
 
  const formik = useFormik({
    enableReinitialize: false,
    initialValues: enquiry
      ? {
          first_shipper_name: enquiry.first_shipper_name || "",
          first_shipper_address: enquiry.first_shipper_address || "",
          second_shipper_name: enquiry.second_shipper_name || "",
          second_shipper_address: enquiry.second_shipper_address || "",
          first_consignee_name: enquiry.first_consignee_name || "",
          first_consignee_address: enquiry.first_consignee_address || "",
          second_consignee_name: enquiry.second_consignee_name || "",
          second_consignee_address: enquiry.second_consignee_address || "",
          notify_party_1: enquiry.notify_party_1 || "",
          notify_party_1_address: enquiry.notify_party_1_address || "",
          notify_party_2: enquiry.notify_party_2 || "",
          notify_party_2_address: enquiry.notify_party_2_address || "",
          commercial_invoice_number: enquiry.commercial_invoice_number || "",
          commercial_invoice_date: enquiry.commercial_invoice_date || "",
          marks_and_packages: enquiry.marks_and_packages || "",
          net_weight: enquiry.net_weight || "",
          iec_number: enquiry.iec_number || "",
          gross_weight: enquiry.gross_weight || "",
          General_Remarks: enquiry.General_Remarks || "",
          Status: enquiry.Status || "",
          Status_client: enquiry.Status_client || "",
        }
      : {
          first_shipper_name: "",
          first_shipper_address: "",
          second_shipper_name: "",
          second_shipper_address: "",
          first_consignee_name: "",
          first_consignee_address: "",
          second_consignee_name: "",
          second_consignee_address: "",
          notify_party_1: "",
          notify_party_1_address: "",
          notify_party_2: "",
          notify_party_2_address: "",
          commercial_invoice_number: "",
          commercial_invoice_date: "",
          marks_and_packages: "",
          net_weight: "",
          iec_number: "",
          gross_weight: "",
          General_Remarks: "",
          Status: "",
          Status_client: "",
        },
    validationSchema: Yup.object({
      first_shipper_name: Yup.string().required("Required"),
      first_shipper_address: Yup.string().required("Required"),
      first_consignee_name: Yup.string().required("Required"),
      first_consignee_address: Yup.string().required("Required"),
      second_shipper_name:
        enquiry?.switch_bl === "Yes"
          ? Yup.string().required("Required")
          : Yup.string().notRequired(),
      second_shipper_address:
        enquiry?.switch_bl === "Yes"
          ? Yup.string().required("Required")
          : Yup.string().notRequired(),
      second_consignee_name:
        enquiry?.switch_bl === "Yes"
          ? Yup.string().required("Required")
          : Yup.string().notRequired(),
      second_consignee_address:
        enquiry?.switch_bl === "Yes"
          ? Yup.string().required("Required")
          : Yup.string().notRequired(),
      notify_party_1: Yup.string().required("Required"),
      notify_party_1_address: Yup.string().required("Required"),
      notify_party_2: Yup.string().required("Required"),
      notify_party_2_address: Yup.string().required("Required"),
      commercial_invoice_number: Yup.string().required("Required"),
      commercial_invoice_date: Yup.date().required("Required"),
      marks_and_packages: Yup.string().required("Required"),
      net_weight: Yup.number()
        .typeError("Must be a number")
        .required("Required"),
      iec_number: Yup.string().required("Required"),
      gross_weight: Yup.number()
        .typeError("Must be a number")
        .required("Required"),
      General_Remarks: Yup.string().required("Required"),
    }),
    onSubmit: () => {
      setShowConfirm(true);
    },
  });
  const handleConfirm = async () => {
    setShowConfirm(false);
    try {
      const payload = {
        ...formik.values,
        enq_id: id,
        net_weight: parseFloat(formik.values.net_weight),
        gross_weight: parseFloat(formik.values.gross_weight),
        notificationType: "shared",
      };
      await api.post(`/si/createShippingInstruction`, payload);
      setShowSuccess(true);
    } catch (error) {
      console.error(error);
    }
  };
  if (!enquiry) return <div>Loading...</div>;
  console.log("formik", formik);
  // useEffect(() => {
  //   console.log("formik", formik);
  // }, [formik.values, formik.errors, formik.touched]);
 
  return (
    <>
      <Breadcrumbs />
      <form onSubmit={formik.handleSubmit}>
        <div className="row g-3 mb-3">
          <div className="col-sm-6 col-md-4">
            <InputField
              required={true}
              label="Shipper Name"
              name="first_shipper_name"
              clsname="required"
              placeholder="Enter the first  Shipper Name"
              value={formik.values.first_shipper_name}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={
                formik.touched.first_shipper_name &&
                formik.errors.first_shipper_name
              }
            />
          </div>
          <div className="col-sm-6 col-md-4">
            <InputField
              required={true}
              label="Shipper Address"
              name="first_shipper_address"
              clsname="required"
              placeholder="Enter the Shipper Address"
              value={formik.values.first_shipper_address}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={
                formik.touched.first_shipper_address &&
                formik.errors.first_shipper_address
              }
            />
          </div>
          <div className="col-sm-6 col-md-4">
            <InputField
              required={true}
              label="Consignee Name"
              name="first_consignee_name"
              clsname="required"
              placeholder="Enter the Consignee Name"
              value={formik.values.first_consignee_name}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={
                formik.touched.first_consignee_name &&
                formik.errors.first_consignee_name
              }
            />
          </div>
          <div className="col-sm-6 col-md-4">
            <InputField
              required={true}
              label="Consignee Address"
              name="first_consignee_address"
              clsname="required"
              placeholder="Enter the Consignee Address"
              value={formik.values.first_consignee_address}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={
                formik.touched.first_consignee_address &&
                formik.errors.first_consignee_address
              }
            />
          </div>
          <div className="col-sm-6 col-md-4">
            <InputField
              required={true}
              label="Notify Party 1"
              name="notify_party_1"
              clsname="required"
              placeholder="Enter the Notify Party 1"
              value={formik.values.notify_party_1}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={
                formik.touched.notify_party_1 && formik.errors.notify_party_1
              }
            />
          </div>
          <div className="col-sm-6 col-md-4">
            <InputField
              required={true}
              label="Notify Party 1 Address"
              name="notify_party_1_address"
              clsname="required"
              placeholder="Enter the Notify Party 1 Address"
              value={formik.values.notify_party_1_address}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={
                formik.touched.notify_party_1_address &&
                formik.errors.notify_party_1_address
              }
            />
          </div>
          <div className="col-sm-6 col-md-4">
            <InputField
              label="Notify Party 2"
              name="notify_party_2"
              clsname="required"
              placeholder="Enter the Notify Party 2"
              value={formik.values.notify_party_2}
              onChange={formik.handleChange}
              required={true}
              onBlur={formik.handleBlur}
              error={
                formik.touched.notify_party_2 && formik.errors.notify_party_2
              }
            />
          </div>
          <div className="col-sm-6 col-md-4">
            <InputField
              label="Notify Party 2 Address"
              name="notify_party_2_address"
              clsname="required"
              placeholder="Enter the Notify Party 2 Address"
              value={formik.values.notify_party_2_address}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              required={true}
              error={
                formik.touched.notify_party_2_address &&
                formik.errors.notify_party_2_address
              }
            />
          </div>
          <div className="col-sm-6 col-md-4">
            <InputField
              required={true}
              label="Commercial Invoice Number"
              name="commercial_invoice_number"
              clsname="required"
              placeholder="Enter the Commercial Invoice Number"
              value={formik.values.commercial_invoice_number}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={
                formik.touched.commercial_invoice_number &&
                formik.errors.commercial_invoice_number
              }
            />
          </div>
          {/* <div className="col-sm-6 col-md-4">
            <InputField
             required={true}
              label="Commercial Invoice Date"
              name="commercial_invoice_date"
              type="date"
              placeholder="Enter the Commercial Invoice Date"
              value={formik.values.commercial_invoice_date}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={
                formik.touched.commercial_invoice_date &&
                formik.errors.commercial_invoice_date
              }
            />
          </div> */}
          <div className="col-sm-6 col-md-4">
            <label className="form-label">
              Commercial Invoice Date <span className="text-danger">*</span>
            </label>
 
            <div style={{ position: "relative", width: "100%" }}>
              <DatePicker
                selected={
                  formik.values.commercial_invoice_date
                    ? new Date(formik.values.commercial_invoice_date)
                    : null
                }
                onChange={(date) => {
                  formik.setFieldValue("commercial_invoice_date", date);
                }}
                onBlur={() =>
                  formik.setFieldTouched("commercial_invoice_date", true)
                }
                dateFormat="dd/MM/yyyy"
                placeholderText="Select Commercial Invoice Date"
                className={`form-control w-100 ${
                  formik.touched.commercial_invoice_date &&
                  formik.errors.commercial_invoice_date
                    ? "is-invalid"
                    : ""
                }`}
                calendarClassName="custom-calendar"
                // showMonthDropdown
                // showYearDropdown
                dropdownMode="select"
              />
 
              <CalendarMonthIcon
                style={{
                  position: "absolute",
                  right: "30px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  pointerEvents: "none",
                  color: "#6c757d",
                }}
              />
            </div>
 
            {formik.touched.commercial_invoice_date &&
              formik.errors.commercial_invoice_date && (
                <div className="invalid-feedback">
                  {formik.errors.commercial_invoice_date}
                </div>
              )}
          </div>
          <div className="col-sm-6 col-md-4">
            <InputField
              required={true}
              label="Marks and Number of Packages"
              name="marks_and_packages"
              type="textarea"
              clsname="required"
              maxHeight="48px"
              placeholder="Enter the Marks and Number of Packages"
              inpcls="customtextarea"
              value={formik.values.marks_and_packages}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={
                formik.touched.marks_and_packages &&
                formik.errors.marks_and_packages
              }
            />
          </div>
          <div className="col-sm-6 col-md-4">
            <InputField
              required={true}
              label="Net Weight"
              type="number"
              clsname="required"
              name="net_weight"
              placeholder="Enter the Net Weight"
              value={formik.values.net_weight}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.net_weight && formik.errors.net_weight}
            />
          </div>
          <div className="col-sm-6 col-md-4">
            <InputField
              required={true}
              label="I.E.C Number"
              name="iec_number"
              clsname="required"
              placeholder="Enter the I.E.C. Number"
              value={formik.values.iec_number}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.iec_number && formik.errors.iec_number}
            />
          </div>
          <div className="col-sm-6 col-md-4">
            <InputField
              required={true}
              label="Gross Weight"
              name="gross_weight"
              clsname="required"
              type="number"
              placeholder="Enter the Gross Weight"
              value={formik.values.gross_weight}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.gross_weight && formik.errors.gross_weight}
            />
          </div>
        </div>
        {enquiry && enquiry?.switch_bl === "Yes" && (
          <>
            <h5>Please fill the shipping instructions for BL2</h5>
            <div className="row g-3">
              <div className="col-sm-6 col-md-4">
                <InputField
                  required={true}
                  label="Shipper Name"
                  clsname="required"
                  name="second_shipper_name"
                  placeholder="Enter the Shipper Name"
                  value={formik.values.second_shipper_name}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={
                    formik.touched.second_shipper_name &&
                    formik.errors.second_shipper_name
                  }
                />
              </div>
 
              <div className="col-sm-6 col-md-4">
                <InputField
                  required={true}
                  label="Shipper Address"
                  clsname="required"
                  name="second_shipper_address"
                  placeholder="Enter the Shipper Address"
                  value={formik.values.second_shipper_address}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={
                    formik.touched.second_shipper_address &&
                    formik.errors.second_shipper_address
                  }
                />
              </div>
 
              <div className="col-sm-6 col-md-4">
                <InputField
                  required={true}
                  label="Consignee Name"
                  clsname="required"
                  name="second_consignee_name"
                  placeholder="Enter the Consignee Name"
                  value={formik.values.second_consignee_name}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={
                    formik.touched.second_consignee_name &&
                    formik.errors.second_consignee_name
                  }
                />
              </div>
 
              <div className="col-sm-6 col-md-4">
                <InputField
                  required={true}
                  label="Consignee Address"
                  clsname="required"
                  name="second_consignee_address"
                  placeholder="Enter the Consignee Address"
                  value={formik.values.second_consignee_address}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={
                    formik.touched.second_consignee_address &&
                    formik.errors.second_consignee_address
                  }
                />
              </div>
            </div>
          </>
        )}
 
        <div className="row g-3">
          <div className="col-sm-6 col-md-4">
            <InputField
              required={true}
              label="Remarks"
              name="General_Remarks"
              placeholder="Enter any additional information"
              value={formik.values.General_Remarks}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={
                formik.touched.General_Remarks && formik.errors.General_Remarks
              }
            />
          </div>
        </div>
        <div className="d-flex justify-content-end mt-3">
          <button type="submit" className="btn btn-primary">
            Send Shipping Instructions
          </button>
        </div>
      </form>
      <Modal show={showConfirm} onHide={() => setShowConfirm(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Submission</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure you want to submit this ?</Modal.Body>
        <Modal.Footer>
          <Button
            text="Cancel"
            variant="secondary"
            onClick={() => setShowConfirm(false)}
          />
          <Button text="Confirm" variant="primary" onClick={handleConfirm} />
        </Modal.Footer>
      </Modal>
      <Modal show={showSuccess} onHide={handleSuccessClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Success</Modal.Title>
        </Modal.Header>
        <Modal.Body>Shipping Instructions submitted successfully!</Modal.Body>
        <Modal.Footer>
          <Button text="OK" variant="success" onClick={handleSuccessClose} />
        </Modal.Footer>
      </Modal>
    </>
  );
};
export default ShippingForm;
 